export const props = {} as const;
